import { useEffect, useState } from 'react';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { hashSHA256 } from '@/libs/hash';

export const useDisableBodyScroll = (open: boolean) => {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [open]);
};

export const useHashedFingerprint = () => {
  const [hashedFingerprint, setHashedFingerprint] = useState<string | null>(
    null
  );

  useEffect(() => {
    const getHashedFingerprint = async () => {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      const hashed = await hashSHA256(result.visitorId);
      setHashedFingerprint(hashed);
    };

    getHashedFingerprint();
  }, []);

  return hashedFingerprint;
};

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 640);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  return isMobile;
}